export default "__VITE_ASSET__BGJnwxo0__"